import React, { createContext, useContext, useState, useCallback } from 'react';

const GlobalStateContext = createContext();

export const GlobalStateProvider = ({ children }) => {
  const [resumes, setResumes] = useState([]);
  const [totalResumes, setTotalResumes] = useState(0);
  const [lastFetchTime, setLastFetchTime] = useState(null);
  const [activeFilters, setActiveFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  
  const updateResumes = useCallback((newData, total) => {
    setResumes(newData);
    setTotalResumes(total);
    setLastFetchTime(Date.now());
  }, []);

  const clearCache = useCallback(() => {
    setResumes([]);
    setTotalResumes(0);
    setLastFetchTime(null);
  }, []);

  return (
    <GlobalStateContext.Provider value={{ 
      resumes, 
      totalResumes, 
      lastFetchTime, 
      activeFilters,
      currentPage,
      updateResumes, 
      setActiveFilters,
      setCurrentPage,
      clearCache 
    }}>
      {children}
    </GlobalStateContext.Provider>
  );
};

export const useGlobalState = () => {
  const context = useContext(GlobalStateContext);
  if (!context) {
    throw new Error('useGlobalState must be used within a GlobalStateProvider');
  }
  return context;
};
